import { Tabs, UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { Grid } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import SVG from 'react-inlinesvg';
import { TabInfo } from '../types';

export type Props = {
  tabInfo: TabInfo,
  showTitles?: boolean,
};

const Tab: React.FC<Props> = observer(({ tabInfo, showTitles = false }) => {
  const selected = UiStore.currentTab === tabInfo.tab && UiStore.opened;

  const onClick = React.useCallback(() => {
    UiStore.open();
    UiStore.setTab(tabInfo.tab);
    if (tabInfo.tab === Tabs.Game) {
      if (!UserStore.isLoggedIn) {
        UiStore.setTab(Tabs.Missions);
        UiStore.setShowGame(false);
      } else {
        UiStore.setShowGame(true);
      }
    } else {
      UiStore.setShowGame(false);
    }
  }, [tabInfo]);

  return (
    <Grid
      container
      wrap="nowrap"
      alignItems="center"
      direction="column"
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        backgroundColor: 'transparent',
        border: '1px solid',
        boxSizing: 'border-box',
        borderColor: selected ? (theme) => theme.palette.text.secondary : 'transparent',
        borderRadius: selected ? '8px' : 'none',
        padding: '2px',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          border: '1px solid',
          borderColor: (theme) => theme.palette.text.secondary,
          borderRadius: 8,
        },
      }}
    >
      <SVG style={{ width: '2rem', height: '2rem', fill: 'currentColor' }} src={tabInfo.icon} />
      {
        showTitles && (
          <Grid
            sx={{
              fontSize: '1rem',
              fontWeight: 600,
              lineHeight: '1rem',
              marginTop: (theme) => theme.spacing(0.5),
              color: selected ? (theme) => theme.palette.text.secondary : '#c7c8ce',
            }}
          >
            {tabInfo.title}
          </Grid>
        )
      }
    </Grid>
  );
});

export default Tab;
